import { render, staticRenderFns } from "./PhotoBannerTable.vue?vue&type=template&id=81541afe&scoped=true"
import script from "./PhotoBannerTable.vue?vue&type=script&lang=js"
export * from "./PhotoBannerTable.vue?vue&type=script&lang=js"
import style0 from "./PhotoBannerTable.vue?vue&type=style&index=0&id=81541afe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81541afe",
  null
  
)

export default component.exports